var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprovedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24317 9.20787L0.914062 4.87876L2.00592 3.80606L5.26233 7.06247L6.33503 8.13517L5.24317 9.20787ZM9.57228 9.20787L5.24317 4.87876L6.31587 3.7869L9.57228 7.04331L16.6215 -0.00585938L17.6942 1.086L9.57228 9.20787ZM9.57228 4.87876L8.48043 3.80606L12.2732 0.013296L13.365 1.086L9.57228 4.87876Z",
    fill: "#9EE766"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedIcon);
export default __webpack_public_path__ + "static/media/ApprovedIcon.7e7f3226523ec64f51741020dfd781b3.svg";
export { ForwardRef as ReactComponent };